export type PUR5010_R01TabType = 'item' | 'warehouse' | 'brand';

export const PUR5010_R01_TABS = [
    { id: 'item', label: '품목별 재고' },
    { id: 'warehouse', label: '창고별 재고' },
    { id: 'brand', label: '브랜드별 재고' },
] as const;

export const getDetailRowId = (tabType: PUR5010_R01TabType, row: any): string => {
    switch (tabType) {
        case 'item':
            return `detail_${row?.itemCd || 'EMPTY'}_${row?.brandCd || 'DEFAULT'}_${row?.itemStatus || 'DEFAULT'}`;
        case 'warehouse':
            return `detail_${row?.logicCenter || 'DEFAULT'}_${row?.warehouseCd || 'DEFAULT'}_${row?.itemCd || 'EMPTY'}`;
        case 'brand':
            return `detail_${row?.brandCd || 'DEFAULT'}_${row?.logicCenter || 'DEFAULT'}_${row?.warehouseCd || 'DEFAULT'}_${row?.itemCd || 'EMPTY'}`;
        default:
            return `detail_${row?.itemCd || 'EMPTY'}`;
    }
};

export const getUniqueRowKey = (tabType: PUR5010_R01TabType, item: any): string => {
    switch (tabType) {
        case 'item':
            return `${item.itemCd}-${item.brandCd || 'DEFAULT'}-${item.itemStatus || 'DEFAULT'}`;
        case 'warehouse':
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}`;
        case 'brand':
            return `${item.brandCd || 'DEFAULT'}-${item.logicCenter || 'DEFAULT'}-${item.warehouseCd || 'DEFAULT'}-${item.itemCd}`;
        default:
            return `${item.itemCd || 'EMPTY'}`;
    }
};

export interface PUR5010_R01SubtotalConfig {
    groupBy: string;
    displayFields: string[];
    aggregateFields: string[];
}

export const SUBTOTAL_CONFIGS: Record<PUR5010_R01TabType, PUR5010_R01SubtotalConfig> = {
    item: {
        groupBy: 'itemCd',
        displayFields: ['itemCd', 'itemNm', 'itemSpec', 'itemUnit'],
        aggregateFields: ['stockQty', 'reservQty', 'availableQty'],
    },
    warehouse: {
        groupBy: 'itemCd',
        displayFields: ['itemCd', 'itemNm', 'itemSpec', 'itemUnit', 'logicCenter', 'logicCenterNm', 'warehouseCd', 'warehouseNm'],
        aggregateFields: ['stockQty', 'reservQty', 'availableQty'],
    },
    brand: {
        groupBy: 'itemCd',
        displayFields: ['itemCd', 'itemNm', 'itemSpec', 'itemUnit', 'brandCd', 'brandNm', 'logicCenter', 'logicCenterNm', 'warehouseCd', 'warehouseNm'],
        aggregateFields: ['stockQty', 'reservQty', 'availableQty'],
    },
};
